// extracted by mini-css-extract-plugin
export var cartListItem = "cart-item-module--cartListItem--1f276";
export var cartListItemImg__placeholder = "cart-item-module--cartListItemImg__placeholder--22ed6";
export var cartListItem__content = "cart-item-module--cartListItem__content--b7581";
export var cartListItem__img = "cart-item-module--cartListItem__img--61c21";
export var cartListItem__price = "cart-item-module--cartListItem__price--c1f34";
export var cartListItem__remove = "cart-item-module--cartListItem__remove--8f886";
export var cartListItem__title = "cart-item-module--cartListItem__title--3b4f2";